(() => {
  const reveal = () => {
    const items = document.querySelectorAll('[data-poli-reveal]:not([data-poli-ready])');
    if (!items.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach((item) => item.setAttribute('data-poli-ready', 'true'));
      return;
    }
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.setAttribute('data-poli-ready', 'true');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    items.forEach((item) => observer.observe(item));
  };

  const initCopyButtons = (root = document) => {
    root.querySelectorAll('[data-poli-copy-code]:not([data-poli-copy-ready])').forEach((button) => {
      button.setAttribute('data-poli-copy-ready', 'true');
      const originalText = button.textContent;
      button.addEventListener('click', async () => {
        const value = button.getAttribute('data-copy-value') || '';
        try {
          await navigator.clipboard.writeText(value);
        } catch (error) {
          const input = document.createElement('textarea');
          input.value = value;
          input.setAttribute('readonly', '');
          input.style.position = 'fixed';
          input.style.opacity = '0';
          document.body.appendChild(input);
          input.select();
          document.execCommand('copy');
          input.remove();
        }
        button.textContent = 'Copiato';
        window.setTimeout(() => { button.textContent = originalText; }, 1800);
      });
    });
  };

  const initDiscountPopups = (root = document) => {
    root.querySelectorAll('[data-poli-discount-popup]:not([data-poli-popup-ready])').forEach((popup) => {
      popup.setAttribute('data-poli-popup-ready', 'true');

      const popupId = popup.getAttribute('data-popup-id') || 'default';
      const storageKey = `poli-discount-popup-${popupId}`;
      const delay = Number.parseInt(popup.getAttribute('data-delay') || '4000', 10);
      const frequencyDays = Number.parseInt(popup.getAttribute('data-frequency-days') || '7', 10);
      const isDesignMode = popup.getAttribute('data-design-mode') === 'true';
      const isSuccess = Boolean(popup.querySelector('[data-poli-popup-success]'));
      const emailInput = popup.querySelector('input[type="email"]');
      let timer;

      const show = () => {
        popup.hidden = false;
        requestAnimationFrame(() => {
          popup.classList.add('is-open');
          document.body.classList.add('poli-popup-open');
          window.setTimeout(() => emailInput?.focus({ preventScroll: true }), 120);
        });
      };

      const close = (remember = true) => {
        window.clearTimeout(timer);
        popup.classList.remove('is-open');
        document.body.classList.remove('poli-popup-open');
        if (remember && !isDesignMode) {
          try {
            localStorage.setItem(storageKey, String(Date.now() + frequencyDays * 86400000));
          } catch (error) {}
        }
        window.setTimeout(() => { popup.hidden = true; }, 260);
      };

      popup.querySelectorAll('[data-poli-popup-close]').forEach((button) => {
        button.addEventListener('click', () => close(true));
      });

      popup.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') close(true);
      });

      let shouldShow = isSuccess || isDesignMode;
      if (!shouldShow) {
        try {
          const hiddenUntil = Number.parseInt(localStorage.getItem(storageKey) || '0', 10);
          shouldShow = !hiddenUntil || Date.now() > hiddenUntil;
        } catch (error) {
          shouldShow = true;
        }
      }

      if (shouldShow) {
        timer = window.setTimeout(show, isSuccess || isDesignMode ? 120 : Math.max(0, delay));
      }
    });
  };

  const init = (root = document) => {
    reveal();
    initCopyButtons(root);
    initDiscountPopups(root);
  };

  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:select', (event) => {
    const popup = event.target.querySelector?.('[data-poli-discount-popup]');
    if (popup) {
      popup.hidden = false;
      requestAnimationFrame(() => popup.classList.add('is-open'));
    }
  });
})();
